<template>
  <div v-if="hasProducts" class="product-highlights">
    <oie-product-carousel
      :id="`${id}`"
      :closable="false"
      :products="sortedProducts"
      theme="secondary"
      @buy-product="handleBuyProduct($event)"></oie-product-carousel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import httpService from '@/core/http-service'
import priceService from '@/core/price-service'
import gtm from '@/core/enhanced-ecommerce-gtm'
import _ from 'lodash'

export default {
  props: {
    productIds: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    gaListType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      products: []
    }
  },
  computed: {
    ...mapGetters('commerce', ['numberOfItems']),
    ...mapGetters('ui', ['useVat']),
    ...mapGetters(['enableGtm']),
    hasProducts() { return this.products.length > 0 },
    sortedProducts() {
      return _.orderBy(this.products, 'newsPriority')
    }
  },
  watch: {
    numberOfItems() {
      this.getProducts()
    },
    async useVat() {
      if(this.products.length) {
        const productIds = _.flatMap(this.products, 'id')
        await this.setProductListPrices(productIds, this.products)
      }
    }
  },
  async mounted() {
    await this.getProducts()
  },
  methods: {
    async getProducts() {
      const response = await httpService.post('completeProducts', { page: 1, pageSize: this.productIds.length, productIds: this.productIds })
      const products = response.data.data
      const productIds = _.flatMap(response.data.data, 'id')
      await this.setProductListPrices(productIds, products)
      this.products = products
    },
    async setProductListPrices(ids, products) {
      const priceInformation = await httpService.post('productListPrices', { productId: ids })
      priceService.populatePricesFromBackend(priceInformation.data, products)
    },
    handleBuyProduct($event) {
      const { addedProduct } = $event
      if (addedProduct && this.enableGtm) {
        const gtmObject = gtm.createGtmItem(
          addedProduct.itemId,
          addedProduct.displayName,
          addedProduct.item.purchasedToVehicle,
          addedProduct.item.purchasedOnCategory,
          this.formatPriceWithoutCurrency(addedProduct.price),
          1,
          this.gaListType)

        gtm.addToCart(gtmObject)
      }
    }
  }

}
</script>

<style>

</style>
